import { configureStore } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import ErrorBoundary from "@/components/ErrorBoundary";
import Config from "@/config";
import App from "@/pages/index";
import "@/pages/styles/global.scss";
import { reducer } from "@/store/reducer";
import pkg from "../package.json";

Sentry.init({
    dsn: Config.sentry.dsn,
    debug: import.meta.env.DEV,
    enabled: import.meta.env.PROD,
    environment: import.meta.env.MODE,
    release: pkg.version,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
});

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }),
});

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("缺少应用挂载节点 #root");

createRoot(rootElement).render(
    <StrictMode>
        <ErrorBoundary>
            <Provider store={store}>
                <HashRouter>
                    <App />
                </HashRouter>
            </Provider>
        </ErrorBoundary>
    </StrictMode>,
);
